import { useEffect, useRef, useState } from "react";
import SvgIcon from "../../../../../../parts/SvgIcon";

const WorkoutParamsRow = ({
  exercise,
  newExercise,
  editDayMode,
  editable,
  handleInput,
  exerciseId,
}) => {
  const source = newExercise || exercise;
  const tempoFromSource = source.tempo || "";

  const [repsPerSide, setRepsPerSide] = useState(!!source.repsPerSide);
  const [tempoChecked, setTempoChecked] = useState(!!tempoFromSource);
  const [tempoValue, setTempoValue] = useState(tempoFromSource);
  const tempoInputRef = useRef(null);

  useEffect(() => {
    if (!editDayMode) {
      const src = newExercise || exercise;
      setRepsPerSide(!!src.repsPerSide);
      setTempoChecked(!!src.tempo);
      setTempoValue(src.tempo || "");
    }
  }, [editDayMode, exercise, newExercise]);

  const isEditing = editDayMode && editable;

  if (!isEditing && !repsPerSide && !tempoValue) return null;

  if (!isEditing) {
    return (
      <div className="flex items-center gap-4 py-1 px-2 mt-1 rounded-lg text-sm bg-(--white-05)">
        {repsPerSide && (
          <span className="flex items-center gap-1">
            <SvgIcon src="/img/new-icons/reps-per-side.svg" />
            Reps per side
          </span>
        )}
        {tempoValue && (
          <span className="flex items-center gap-1">
            <SvgIcon src="/img/new-icons/tempo.svg" />
            Tempo: {tempoValue}
          </span>
        )}
      </div>
    );
  }

  const onToggleRepsPerSide = () => {
    const next = !repsPerSide;
    setRepsPerSide(next);
    handleInput({ value: next, field: "repsPerSide", exerciseId });
  };

  const onToggleTempo = () => {
    const next = !tempoChecked;
    setTempoChecked(next);
    if (next) {
      handleInput({ value: true, field: "_tempoChecked", exerciseId });
      setTimeout(() => tempoInputRef.current?.focus(), 0);
    } else {
      handleInput({ value: null, field: "tempo", exerciseId });
      handleInput({ value: false, field: "_tempoChecked", exerciseId });
    }
  };

  const onTempoChange = (e) => {
    setTempoValue(e.target.value);
    handleInput({ value: e.target.value, field: "tempo", exerciseId });
  };

  return (
    <div className="flex flex-wrap items-center gap-4 py-2 text-sm">
      <label className="flex! items-center gap-1 cursor-pointer opacity-100! mb-0!">
        <input
          type="checkbox"
          checked={repsPerSide}
          onChange={onToggleRepsPerSide}
        />
        <SvgIcon src="/img/new-icons/reps-per-side.svg" />
        Reps per side
      </label>
      <label className="flex! items-center gap-1 cursor-pointer opacity-100! mb-0!">
        <input
          type="checkbox"
          checked={tempoChecked}
          onChange={onToggleTempo}
        />
        <SvgIcon src="/img/new-icons/tempo.svg" />
        Tempo
      </label>
      {tempoChecked && (
        <input
          ref={tempoInputRef}
          type="text"
          value={tempoValue}
          onChange={onTempoChange}
          placeholder="e.g. 4-0-1-3"
          className="form-input text-sm max-w-32"
        />
      )}
    </div>
  );
};

export default WorkoutParamsRow;
